import axiosClient from "../utils/axiosClient";

export const updateRoles = (roles)=>axiosClient.put('/roles/addroles', roles)